import { BoxGeometry, Mesh, ShaderMaterial, SphereGeometry } from "three";
import glslify from 'glslify';
import { MyShaderMat } from "./MyShaderMat";

export class BrushMesh extends Mesh{


    mat:MyShaderMat;

    constructor(){

        let geo = new SphereGeometry(0.1,10,10);
        let mat = new MyShaderMat();

        super(geo,mat.mat);

        this.mat = mat;

    }

    update(rr:number,gg:number,bb:number): void {
        
        this.mat.updateColor(rr,gg,bb);

    }


}
